import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentEmptyComponent } from './components/content-empty/content-empty.component';
import { ExtendDatePipe } from './pipes/date.pipe';
import { MatTableResponsiveDirective } from './directive/mat-table-responsive.directive';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DialogMessageComponent, SnackBarService } from './services/snackbar/snackbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { DecimalLimitDirective } from './directive/decimal-limit.directive';
import { ImagePreloader } from './directive/lazy-load-image.directive';
import { LandingComponent } from './components/landing/landing.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SwiperDirective } from './directive/swiper.directive';
import { DynamicHostDirective } from './directive/dynamic-host.directive';
// import { PaginatorComponent } from './components/paginator/paginator.component';

@NgModule({
  declarations: [
    ContentEmptyComponent, 
    ExtendDatePipe, 
    MatTableResponsiveDirective, 
    DialogMessageComponent,
    DecimalLimitDirective,
    ImagePreloader,
    LandingComponent,
    SafeHtmlPipe,
    SwiperDirective,
    DynamicHostDirective,
    // PaginatorComponent
  ],
  imports: [
    CommonModule,
    ImageCropperModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    ReactiveFormsModule
  ],
  exports: [
    ContentEmptyComponent,
    ExtendDatePipe,
    DecimalLimitDirective,
    MatTableResponsiveDirective,
    ImageCropperModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    ImagePreloader,
    SafeHtmlPipe,
    SwiperDirective,
    DynamicHostDirective,
  ],
  entryComponents: [DialogMessageComponent],
  providers: [
    ExtendDatePipe,
    SnackBarService,
    ImagePreloader,
    SafeHtmlPipe
  ]

})

export class SharedModule { }
